import type { Coach, CourseItemType, Form, WorkflowType } from '@coursera/event-pulse-types';
import { createTrackerStore } from '@coursera/event-pulse/react';

export type CoachTrackingData = {
  data: {
    courseId?: string;
    itemId?: string;
    degreeId?: string;
    mode: string;
    location?: Coach['location'];
    itemType?: CourseItemType;
    form?: Form;
    courseBuilderWorkflowId?: string;
    courseBuilderWorkflowType?: { workflowType: WorkflowType };
  };
};

const [CoachTrackingDataProvider, useCoachTrackingContext] = createTrackerStore<CoachTrackingData>();

export { CoachTrackingDataProvider, useCoachTrackingContext };
